import { GlobalResponse, TemplateRequest } from '~/models/Commons ';
import { api } from '../api';
import { TEMPLATES } from '../endpoints';
import { SET_COMPONENTS } from '~/store/feature/Components';
import buildCopyMutation from '../generics/BuildCopyMutation';
import { getHeaders } from '../generics/Header';


const extendedApiSlice = api.injectEndpoints({
  endpoints: builder => ({
    getVmTemplates: builder.query<
      GlobalResponse<any[]>,
      { page: number; size: number; active: boolean }
    >({
      query: ({ page, size, active }) => ({
        url: `${TEMPLATES}?page=${page}&size=${size}&active=${active}`,
        method: 'GET',
        credentials: 'include',
        headers:getHeaders()
      }),
      providesTags: ['VmTemplates'],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(SET_COMPONENTS(data.payload));
        } catch (error) {
          console.error('Error fetching templates:', error);
        }
      },
    }),

    saveVmTemplates: builder.mutation<
      GlobalResponse<TemplateRequest>,
      TemplateRequest
    >({
      query: data => {
        const token = sessionStorage.getItem('access_token');
        if (!token) throw new Error('No access token found');

        return {
          url: TEMPLATES,
          method: 'POST',
          body: data,
          credentials: 'include',
          headers: getHeaders()
        }
      },
      invalidatesTags: ['VmTemplates'],
    }),

    updateVmTemplates: builder.mutation<
      GlobalResponse<TemplateRequest>,
      { id: number; data: TemplateRequest }
    >({
      query: ({ id, data }) => ({
        url: `${TEMPLATES}/${id}`,
        method: 'PUT',
        body: data,
        credentials: 'include',
        headers:getHeaders()
      }),
      invalidatesTags: ['VmTemplates'],
    }),

    deleteVmTemplates: builder.mutation<
      GlobalResponse<TemplateRequest>,
      number
    >({
      query: templateId => ({
        url: `${TEMPLATES}/${templateId}`,
        method: 'DELETE',
        credentials: 'include',
        headers:getHeaders()
      }),
      invalidatesTags: ['VmTemplates'],
    }),

    copyVmTemplate: buildCopyMutation(builder, TEMPLATES),
  }),
});

export const {
  useGetVmTemplatesQuery,
  useLazyGetVmTemplatesQuery,
  useSaveVmTemplatesMutation,
  useUpdateVmTemplatesMutation,
  useDeleteVmTemplatesMutation,
  useCopyVmTemplateMutation,
} = extendedApiSlice;